import { render } from "./DashboardDonations.vue?vue&type=template&id=555f8032"
import script from "./DashboardDonations.vue?vue&type=script&lang=js"
export * from "./DashboardDonations.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/donorsweb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__